export const MY_TAGS_ITEM_ID = 'my tags menu item';

export const COMPANY_TAGS_ITEM_ID = 'company menu item';
